import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import {
  RoomRecordingDeleteCmd,
  RoomRecordingSetCmd
} from "@youm-front/room/domain";
import { RoomRecordingActions } from "../actions";

@Injectable()
export class RoomRecordingFacade {
  constructor(private readonly store: Store) {}

  roomRecordingDelete(roomRecordingDeleteCmd: RoomRecordingDeleteCmd) {
    this.store.dispatch(
      RoomRecordingActions.roomRecordingDelete({
        roomRecordingDeleteCmd
      })
    );
  }

  roomRecordingSet(roomRecordingSetCmd: RoomRecordingSetCmd) {
    this.store.dispatch(
      RoomRecordingActions.roomRecordingSet({
        roomRecordingSetCmd
      })
    );
  }
}
